import { render } from "./FormButtonBegin.vue?vue&type=template&id=3cdd8bbc"
import script from "./FormButtonBegin.vue?vue&type=script&lang=js"
export * from "./FormButtonBegin.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__